var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "background_menu" } }, [
    _c("section", { staticClass: "menu-ctrl" }, [
      _c("span", { staticClass: "menu-ctrl__text" }, [
        _vm._v(_vm._s(_vm.$t("__background.top_hint")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "icon-container" },
        [
          _c("QpeTooltip", {
            scopedSlots: _vm._u([
              {
                key: "hovered_item",
                fn: function() {
                  return [
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "white" },
                        on: { click: _vm.close_all }
                      },
                      [
                        _vm._v(
                          "\n                        icon-unfold-less\n                    "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "tooltip_content",
                fn: function() {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("__map_obs.close_all_tree")))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("QpeTooltip", {
            scopedSlots: _vm._u([
              {
                key: "hovered_item",
                fn: function() {
                  return [
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "white" },
                        on: { click: _vm.cancel_all }
                      },
                      [
                        _vm._v(
                          "\n                        icon-cancle-select                        \n                    "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "tooltip_content",
                fn: function() {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$t("__map_obs.cancel_all")))])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "background" } }, [
      _vm.init_items.length > 0
        ? _c(
            "div",
            [
              _c("TreeView", {
                ref: "child_treeview",
                attrs: {
                  name: "background",
                  current_tab: "geomap",
                  init_items: _vm.init_items,
                  checked_selectors: _vm.checked_selectors,
                  init_opened_layers: _vm.init_opened_layers,
                  opened_with_btn: true,
                  enable_all_select_in_treeview_children_radios: true,
                  selected_product_count_callback:
                    _vm.selected_product_count_callback,
                  special_list: _vm.special_list
                },
                on: { control_special_list: _vm._control_special_checkboxes }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }